import React from 'react'
import { useDispatch } from 'react-redux';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { connect, useSelector } from 'react-redux';
import { hideModal } from '../../store/actions/index';
import ProductSystemItemsTables from '../Shared/ProductSystemItemsTables';
import { updateProductSolution } from '../../store/actions/index';
import WizardNavigation from '../Wizard/WizardNavigation';
import { useTranslation } from 'react-i18next';

const EditProductSolutionModal = (props) => {

  // Als Datenspeicher wird der WizardReducer genutzt.
  const dispatch = useDispatch();
  let calculationResult = {};
  let items = props.formObject.selectedItems;
  let calcData = props.formObject.calculator;

  const { t } = useTranslation();


  const projectId = useSelector(state => state.inventory.productSolutions[props.formObject.productSolutionId].project_id);

  const handleSubmit = () => { 
    dispatch( updateProductSolution(projectId, props.formObject.productSolutionId, items, calcData, calculationResult) ).then( dispatch(hideModal())) ;
  }

  const sendCalculatorToModal = () => {
    return (calcDataFromTable) => {
        calcData = calcDataFromTable;
    }
  }

  const sendCalculatorResultToModal = () => {
    return (calculationResultFromTable) => {
        calculationResult = calculationResultFromTable;
    }
  }

  const sendItemsToModal = () => {
    return (selectedItems) => {
        items = selectedItems;
    }
  }

  return (
  	<Modal show={true} onHide={props.hideModal} animation={true}  dialogClassName="modal-xlg">
  		<div className="modal-header">
  			<h5 className="modal-title">{props.modalTitle}</h5>
  			<button type="button" onClick={props.hideModal} className="close btn btn-round" data-dismiss="modal" aria-label="Close"> <i className="material-icons">close</i>
  			</button>
  		</div>
  		<Modal.Body>
        <WizardNavigation selectedSteps={props.formObject.wizardConfiguration} disabledNavigation={true}/>
        <ProductSystemItemsTables
          productSolutionId={props.formObject.productSolutionId}
          selectedSteps={props.formObject.wizardConfiguration}
          productSystem={props.formObject.productSystemId}
          selectedItems={props.formObject.selectedItems}
          sendItemsToModal={sendItemsToModal}
          sendCalculatorToModal={sendCalculatorToModal}
          sendCalculatorResultToModal={sendCalculatorResultToModal}
          calculator={props.formObject.calculator}
          modalVersion={true}
          onSave={handleSubmit}/>

  		</Modal.Body>
  		<Modal.Footer>
  			<Button variant="secondary" onClick={props.hideModal}>{t( 'modals.common.button.close' )}</Button>
  			<button type="submit" onClick={handleSubmit} className="btn btn-primary">{t( 'modals.common.button.save' )}</button>
  		</Modal.Footer>
  	</Modal>
  )
}


const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal())
})

export default connect(null, mapDispatchToProps)(EditProductSolutionModal)



// WEBPACK FOOTER //
// ./src/components/Modals/EditProductSolutionModal.js